module.exports = __webpack_public_path__ + "static/media/figma-logo.e24035d1.png";